import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

type Error = {
  blocker: boolean,
  message: string,
  type: string,
}

type ErrorProps = {
  errors: Error[],
}

const Errors = (props: ErrorProps) => {
  const { errors } = props

  if (!errors || !errors.length){
    return null
  }

  return (
    <Box flexDirection="column" marginTop="large" padding="large" variant="whiteGrey">
      {errors.map((error, index) => {
        const { blocker, message, type } = error

        return (
          <Box fontSize="small" key={type} lineHeight="1.3" marginTop={index === 0 ? null : 'medium'}>
            <Text color={blocker ? 'red' : 'orange'}>
              <FontAwesomeIcon icon={blocker ? faTimesCircle : faExclamationCircle} />
            </Text>
            <Text color={blocker ? 'red' : 'orange'} marginLeft="small">
              {message}
            </Text>
          </Box>
        )
      })}
    </Box>
  )
}

export default Errors
